<div [ngClass]="{'open': isOpen, 'primary': true}" (click)="toggleClass()">
  <div class="accrd-header">
    <span>Filters</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M9.06055 18.75L15.8105 12L9.06055 5.25"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</div>
<div [ngClass]="{'open': isOpen, 'filters': true}">
  <div class="accrd open">
    <div class="accrd-header" (click)="toggleClassToNearestElement($event)">
      <span>Price</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M9.06055 18.75L15.8105 12L9.06055 5.25"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="accrd-body">
      <div #rangecontainer class="range-slider htl">
        <input #minpricehlt type="range" id="min-price-hlt" class="min-price" value={{0}} min="0" max="1000" step="10"  (mouseup)="onSelectMinPrice($event)">
        <input #maxpricehlt type="range" id="max-price-hlt" class="max-price" value={{1000}} min="0" max="1000" step="10"  (mouseup)="onSelectMaxPrice($event)">
      </div>
      <div class="min-max">
        <p id="min-value-htl" #minvaluehtl>$50</p>
        <p id="max-value-htl" #maxvaluehtl>$500</p>
      </div>
    </div>
  </div>
  <div class="accrd">
    <div class="accrd-header" (click)="toggleClassToNearestElement($event)">
      <span>Explore Event</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M9.06055 18.75L15.8105 12L9.06055 5.25"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="accrd-body">
      <label class="cst-chkbx" for="music">
        <span class="cst-chkbx-lable">Music</span>
        <input
          type="checkbox"
          id="music"
          name="music"
          value="Music"
        />
        <span class="checkmark"></span>
      </label>
      <label class="cst-chkbx" for="culture">
        <span class="cst-chkbx-lable">Culture</span>
        <input
          type="checkbox"
          id="culture"
          name="culture"
          value="Culture"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
  <div class="accrd">
    <div class="accrd-header" (click)="toggleClassToNearestElement($event)">
      <span>Accommodation type</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M9.06055 18.75L15.8105 12L9.06055 5.25"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="accrd-body">
      <label class="cst-chkbx" for="apartment">
        <span class="cst-chkbx-lable">Appartment</span>
        <input
          type="checkbox"
          id="apartment"
          name="apartment"
          value="Apartment"
        />
        <span class="checkmark"></span>
      </label>
      <label class="cst-chkbx" for="hotel">
        <span class="cst-chkbx-lable">Hotel</span>
        <input
          type="checkbox"
          id="hotel"
          name="hotel"
          value="Hotel"
        />
        <span class="checkmark"></span>
      </label>
      <label class="cst-chkbx" for="other">
        <span class="cst-chkbx-lable">Other</span>
        <input
          type="checkbox"
          id="other"
          name="other"
          value="Other"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
  <div class="accrd">
    <div class="accrd-header" (click)="toggleClassToNearestElement($event)">
      <span>Accommodation type</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M9.06055 18.75L15.8105 12L9.06055 5.25"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="accrd-body">
      <label class="cst-chkbx" for="board_type">
        <span class="cst-chkbx-lable">Board Type</span>
        <input
          type="checkbox"
          id="board_type"
          name="board_type"
          value="Board type"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
  <div class="accrd">
    <div class="accrd-header" (click)="toggleClassToNearestElement($event)">
      <span>Number of bathrooms</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M9.06055 18.75L15.8105 12L9.06055 5.25"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="accrd-body">
      <label class="cst-chkbx" for="no_bathrooms">
        <span class="cst-chkbx-lable">No Bathrooms</span>
        <input
          type="checkbox"
          id="no_bathrooms"
          name="no_bathrooms"
          value="No bathrooms"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
  <div class="accrd">
    <div class="accrd-header" (click)="toggleClassToNearestElement($event)">
      <span>Star Rating</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M9.06055 18.75L15.8105 12L9.06055 5.25"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="accrd-body">
      <div class="star-rating">
        <label class="cst-chkbx" for="5_star">
          <span class="cst-chkbx-lable">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="15"
              viewBox="0 0 17 15"
              fill="none"
            >
              <path
                d="M8.56055 0.5L11.7031 8.18566L16.7878 14.75L8.56055 13.6287L0.333305 14.75L5.41802 8.18566L8.56055 0.5Z"
                fill="black"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="15"
              viewBox="0 0 17 15"
              fill="none"
            >
              <path
                d="M8.56055 0.5L11.7031 8.18566L16.7878 14.75L8.56055 13.6287L0.333305 14.75L5.41802 8.18566L8.56055 0.5Z"
                fill="black"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="15"
              viewBox="0 0 17 15"
              fill="none"
            >
              <path
                d="M8.56055 0.5L11.7031 8.18566L16.7878 14.75L8.56055 13.6287L0.333305 14.75L5.41802 8.18566L8.56055 0.5Z"
                fill="black"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="15"
              viewBox="0 0 17 15"
              fill="none"
            >
              <path
                d="M8.56055 0.5L11.7031 8.18566L16.7878 14.75L8.56055 13.6287L0.333305 14.75L5.41802 8.18566L8.56055 0.5Z"
                fill="black"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="15"
              viewBox="0 0 17 15"
              fill="none"
            >
              <path
                d="M8.56055 0.5L11.7031 8.18566L16.7878 14.75L8.56055 13.6287L0.333305 14.75L5.41802 8.18566L8.56055 0.5Z"
                fill="black"
              />
            </svg>
          </span>
          <input
            type="checkbox"
            id="5_star"
            name="5_star"
            value="5 Star"
          />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
  <div class="accrd">
    <div class="accrd-header" (click)="toggleClassToNearestElement($event)">
      <span>Stay facilities</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M9.06055 18.75L15.8105 12L9.06055 5.25"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="accrd-body">
      <label class="cst-chkbx" for="free_wifi">
        <span class="cst-chkbx-lable">No Bathrooms</span>
        <input
          type="checkbox"
          id="free_wifi"
          name="free_wifi"
          value="Free WiFi"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
  <div class="accrd">
    <div class="accrd-header" (click)="toggleClassToNearestElement($event)">
      <span>Show 30 more</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M9.06055 18.75L15.8105 12L9.06055 5.25"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="accrd-body">
      <p class="show-more">+24 more</p>
    </div>
  </div>
</div>